/**
 * In-product feedback (migration 0081) — the contract between the header button, POST /feedback
 * and the platform console's review screen. One home for the enums and limits so the button, the
 * API and the admin page cannot drift on what a category or a status is called.
 */
import { z } from "zod";
export const FEEDBACK_CATEGORIES = ["bug", "idea", "praise", "other"];
export const FEEDBACK_CATEGORY_LABELS = {
    bug: "Something is broken",
    idea: "An idea or improvement",
    praise: "Something worked well",
    other: "Something else",
};
export const FEEDBACK_STATUSES = ["new", "reviewed", "closed"];
export const FEEDBACK_LIMITS = {
    /** Shorter than this is a stray click, not a note. */
    minMessage: 5,
    maxMessage: 4000,
    maxPagePath: 300,
    maxAdminNote: 2000,
    maxUserAgent: 400,
};
/** POST /feedback body — what the header button sends. */
export const feedbackSubmitSchema = z.object({
    category: z.enum(FEEDBACK_CATEGORIES),
    message: z.string().trim().min(FEEDBACK_LIMITS.minMessage).max(FEEDBACK_LIMITS.maxMessage),
    rating: z.number().int().min(1).max(5).optional(),
    /** The SPA route the button was pressed on; the button fills it, the person never types it. */
    pagePath: z.string().trim().max(FEEDBACK_LIMITS.maxPagePath).optional(),
});
/** PATCH /admin/feedback/{id} body — triage. At least one of the two must be present. */
export const feedbackReviewSchema = z
    .object({
    status: z.enum(FEEDBACK_STATUSES).optional(),
    adminNote: z.string().trim().max(FEEDBACK_LIMITS.maxAdminNote).nullable().optional(),
})
    .refine((v) => v.status !== undefined || v.adminNote !== undefined, {
    message: "Nothing to change — send a status, a note, or both.",
});
//# sourceMappingURL=feedback.js.map